import imageCompression from 'browser-image-compression';
import { PDFDocument } from 'pdf-lib';

/**
 * Compress an image file (JPEG / PNG / HEIC) before upload.
 * Target: max 1500px on longest edge, JPEG quality 0.8
 * Returns a File object.
 */
export async function compressImage(file, onProgress) {
  const options = {
    maxSizeMB: 1.5,
    maxWidthOrHeight: 1500,
    useWebWorker: true,
    fileType: 'image/jpeg',
    initialQuality: 0.8,
    onProgress,
  };
  const compressed = await imageCompression(file, options);
  return new File([compressed], file.name.replace(/\.[^.]+$/, '.jpg'), { type: 'image/jpeg' });
}

/**
 * Compress a PDF by stripping metadata (best-effort via pdf-lib).
 * Returns a File object.
 */
export async function compressPdf(file) {
  const arrayBuffer = await file.arrayBuffer();
  const pdfDoc = await PDFDocument.load(arrayBuffer, { ignoreEncryption: true });
  // Remove common metadata
  pdfDoc.setTitle('');
  pdfDoc.setAuthor('');
  pdfDoc.setSubject('');
  pdfDoc.setKeywords([]);
  pdfDoc.setProducer('');
  pdfDoc.setCreator('');
  const pdfBytes = await pdfDoc.save({ useObjectStreams: true });
  return new File([pdfBytes], file.name, { type: 'application/pdf' });
}

/**
 * Compress any supported file before upload.
 * Returns { file, originalSize, compressedSize }
 */
export async function compressFile(file, onProgress) {
  const originalSize = file.size;
  let compressed = file;

  try {
    if (file.type.startsWith('image/') || file.type === 'image/heic' || file.type === 'image/heif') {
      compressed = await compressImage(file, onProgress);
    } else if (file.type === 'application/pdf') {
      compressed = await compressPdf(file);
    }
    // docx / xlsx passed through as-is
  } catch (err) {
    console.warn('Compression failed, using original:', err);
    compressed = file;
  }

  return { file: compressed, originalSize, compressedSize: compressed.size };
}
